// import React, { useMemo } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { usePartnerFormStore } from "../store/usePartnerFormStore";
// import { StepWizard, type StepConfig } from "../components/ui";
// import PartnerFormStep1 from "../components/PartnerFormStep1";
// import PartnerFormStep2 from "../components/PartnerFormStep2";
// import PartnerFormStep3 from "../components/PartnerFormStep3";
// import PartnerFormStep4 from "../components/PartnerFormStep4";
// import PartnerFormStep5 from "../components/PartnerFormStep5";
// import PartnerFormStep6 from "../components/PartnerFormStep6";
// import PartnerFormSuccess from "../components/PartnerFormSuccess";
// import { Container } from "../components/ui";

// // Step Icons
// const UserIcon = (
//   <svg
//     className="w-5 h-5"
//     fill="none"
//     stroke="currentColor"
//     viewBox="0 0 24 24"
//   >
//     <path
//       strokeLinecap="round"
//       strokeLinejoin="round"
//       strokeWidth={2}
//       d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
//     />
//   </svg>
// );

// const BriefcaseIcon = (
//   <svg
//     className="w-5 h-5"
//     fill="none"
//     stroke="currentColor"
//     viewBox="0 0 24 24"
//   >
//     <path
//       strokeLinecap="round"
//       strokeLinejoin="round"
//       strokeWidth={2}
//       d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
//     />
//   </svg>
// );

// const LocationIcon = (
//   <svg
//     className="w-5 h-5"
//     fill="none"
//     stroke="currentColor"
//     viewBox="0 0 24 24"
//   >
//     <path
//       strokeLinecap="round"
//       strokeLinejoin="round"
//       strokeWidth={2}
//       d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
//     />
//     <path
//       strokeLinecap="round"
//       strokeLinejoin="round"
//       strokeWidth={2}
//       d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
//     />
//   </svg>
// );

// const ChartIcon = (
//   <svg
//     className="w-5 h-5"
//     fill="none"
//     stroke="currentColor"
//     viewBox="0 0 24 24"
//   >
//     <path
//       strokeLinecap="round"
//       strokeLinejoin="round"
//       strokeWidth={2}
//       d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
//     />
//   </svg>
// );

// const DocumentIcon = (
//   <svg
//     className="w-5 h-5"
//     fill="none"
//     stroke="currentColor"
//     viewBox="0 0 24 24"
//   >
//     <path
//       strokeLinecap="round"
//       strokeLinejoin="round"
//       strokeWidth={2}
//       d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
//     />
//   </svg>
// );

// const PaymentIcon = (
//   <svg
//     className="w-5 h-5"
//     fill="none"
//     stroke="currentColor"
//     viewBox="0 0 24 24"
//   >
//     <path
//       strokeLinecap="round"
//       strokeLinejoin="round"
//       strokeWidth={2}
//       d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
//     />
//   </svg>
// );

// const PartnerRegistrationForm: React.FC = () => {
//   const {
//     currentStep,
//     totalSteps,
//     isSubmitted,
//     resetForm,
//     basicInfo,
//     serviceDetails,
//     coverageAreas,
//     additionalInfo,
//     listingDetails,
//     goToStep,
//   } = usePartnerFormStore();

//   // Generate dynamic step summaries based on form state
//   const stepConfigs: StepConfig[] = useMemo(() => {
//     const getBasicInfoSummary = () => {
//       if (basicInfo.fullName && basicInfo.mobileNumber) {
//         return `${basicInfo.fullName}`;
//       }
//       return undefined;
//     };

//     const getServiceSummary = () => {
//       const count = serviceDetails.services.length;
//       if (count > 0) {
//         const categories = new Set(
//           serviceDetails.services.map((s) => s.category),
//         );
//         return `${count} service${count > 1 ? "s" : ""} in ${categories.size} categor${categories.size > 1 ? "ies" : "y"}`;
//       }
//       return undefined;
//     };

//     const getAreaSummary = () => {
//       if (coverageAreas.selectedPlan) {
//         const hexCount = coverageAreas.selectedHexagons.length;
//         const planName = coverageAreas.selectedPlan.planName;
//         return hexCount > 0
//           ? `${planName} — ${hexCount} hexagon${hexCount > 1 ? "s" : ""}`
//           : `${planName} plan selected`;
//       }
//       return undefined;
//     };

//     const getAdditionalSummary = () => {
//       if (additionalInfo.incomeSharingPercentage) {
//         return `${additionalInfo.incomeSharingPercentage}% income share`;
//       }
//       return undefined;
//     };

//     const getListingSummary = () => {
//       if (listingDetails.listingAmount > 0) {
//         return `₹${listingDetails.listingAmount.toFixed(0)}`;
//       }
//       return undefined;
//     };

//     return [
//       {
//         label: "Basic Info",
//         icon: UserIcon,
//         description: "Your business details",
//         summary: getBasicInfoSummary(),
//       },
//       {
//         label: "Services",
//         icon: BriefcaseIcon,
//         description: "Select your services",
//         summary: getServiceSummary(),
//       },
//       {
//         label: "Coverage",
//         icon: LocationIcon,
//         description: "Coverage areas",
//         summary: getAreaSummary(),
//       },
//       {
//         label: "Work & Income",
//         icon: ChartIcon,
//         description: "Additional details",
//         summary: getAdditionalSummary(),
//       },
//       {
//         label: "Summary",
//         icon: DocumentIcon,
//         description: "Review selections",
//         summary: getListingSummary(),
//       },
//       {
//         label: "Payment",
//         icon: PaymentIcon,
//         description: "Complete registration",
//         summary: undefined,
//       },
//     ];
//   }, [
//     basicInfo,
//     serviceDetails,
//     coverageAreas,
//     additionalInfo,
//     listingDetails,
//   ]);

//   // Show success screen if form is submitted
//   if (isSubmitted) {
//     return <PartnerFormSuccess />;
//   }

//   const handleResetForm = () => {
//     if (
//       window.confirm(
//         "Are you sure you want to reset the form? All your progress will be lost.",
//       )
//     ) {
//       resetForm();
//     }
//   };

//   const handleStepClick = (step: number) => {
//     // Only allow going back to previous steps
//     if (step < currentStep) {
//       goToStep(step);
//     }
//   };

//   const renderStep = () => {
//     switch (currentStep) {
//       case 1:
//         return <PartnerFormStep1 />;
//       case 2:
//         return <PartnerFormStep2 />;
//       case 3:
//         return <PartnerFormStep3 />;
//       case 4:
//         return <PartnerFormStep4 />;
//       case 5:
//         return <PartnerFormStep5 />;
//       case 6:
//         return <PartnerFormStep6 />;
//       default:
//         return <PartnerFormStep1 />;
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-sky-50 via-blue-50/40 to-sky-50 py-4 md:py-8 relative overflow-hidden">
//       {/* Animated Background Elements - Hidden on mobile */}
//       <div className="hidden md:block absolute inset-0 overflow-hidden pointer-events-none">
//         <div className="absolute -top-40 -right-40 w-80 h-80 bg-primary-200/20 rounded-full blur-3xl animate-pulse" />
//         <div
//           className="absolute -bottom-40 -left-40 w-80 h-80 bg-primary-300/20 rounded-full blur-3xl animate-pulse"
//           style={{ animationDelay: "1s" }}
//         />
//       </div>

//       <Container>
//         <div className="max-w-4xl mx-auto relative z-10 px-3 md:px-0">
//           {/* Compact Header for Mobile */}
//           <motion.div
//             initial={{ opacity: 0, y: -20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5 }}
//             className="mb-4 md:mb-6"
//           >
//             {/* Mobile Header - More compact */}
//             <div className="md:hidden flex items-center justify-between gap-3">
//               <div className="flex items-center gap-3">
//                 <div className="relative bg-white p-2 rounded-xl shadow-md border border-primary-100">
//                   <img
//                     src="/logo.png"
//                     alt="Setgo Logo"
//                     className="h-8 w-8 object-contain"
//                   />
//                 </div>
//                 <div>
//                   <h1 className="text-lg font-bold text-secondary-900">
//                     Partner Registration
//                   </h1>
//                   <p className="text-xs text-secondary-500">
//                     Join Setgo Network
//                   </p>
//                 </div>
//               </div>
//               {currentStep > 1 && (
//                 <button
//                   onClick={handleResetForm}
//                   className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors"
//                   title="Reset form"
//                 >
//                   <svg
//                     className="h-5 w-5"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
//                     />
//                   </svg>
//                 </button>
//               )}
//             </div>

//             {/* Desktop Header */}
//             <div className="hidden md:block text-center">
//               <div className="inline-flex items-center justify-center mb-4">
//                 <div className="relative">
//                   <div className="absolute inset-0 bg-primary-500/20 rounded-full blur-xl" />
//                   <div className="relative bg-white p-4 rounded-2xl shadow-lg border-2 border-primary-100">
//                     <img
//                       src="/logo.png"
//                       alt="Setgo Logo"
//                       className="h-12 w-12 object-contain"
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
//                 <div className="flex-1">
//                   <h1 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-primary-600 to-primary-800 bg-clip-text text-transparent mb-2">
//                     Build Your Business with Setgo
//                   </h1>
//                   <p className="text-secondary-600 text-base md:text-lg">
//                     Complete the form below to list your business on Setgo
//                   </p>
//                 </div>
//                 {currentStep > 1 && (
//                   <button
//                     onClick={handleResetForm}
//                     className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-red-600 bg-red-50 border border-red-200 rounded-lg hover:bg-red-100 hover:border-red-300 transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
//                     title="Reset form and clear all data"
//                   >
//                     <svg
//                       className="h-4 w-4"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
//                       />
//                     </svg>
//                     <span>Reset Form</span>
//                   </button>
//                 )}
//               </div>
//             </div>
//           </motion.div>

//           {/* Step Wizard */}
//           <motion.div
//             initial={{ opacity: 0, scale: 0.95 }}
//             animate={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 0.4, delay: 0.1 }}
//             className="mb-4 md:mb-6"
//           >
//             <div className="bg-white/90 backdrop-blur-sm rounded-xl p-4 md:p-6 shadow-lg border border-secondary-100">
//               <StepWizard
//                 currentStep={currentStep}
//                 totalSteps={totalSteps}
//                 steps={stepConfigs}
//                 onStepClick={handleStepClick}
//                 allowStepClick={true}
//               />
//             </div>
//           </motion.div>

//           {/* Form Card */}
//           <AnimatePresence mode="wait">
//             <motion.div
//               key={currentStep}
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               exit={{ opacity: 0, y: -20 }}
//               transition={{ duration: 0.3 }}
//               className="bg-white/95 backdrop-blur-sm rounded-xl shadow-xl border border-secondary-100 p-4 md:p-6 lg:p-8 relative overflow-hidden"
//             >
//               {/* Decorative gradient overlay */}
//               <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary-400 via-primary-500 to-primary-400" />

//               {renderStep()}
//             </motion.div>
//           </AnimatePresence>

//           {/* Mobile Bottom Padding for safe area */}
//           <div className="h-4 md:h-0" />
//         </div>
//       </Container>
//     </div>
//   );
// };

// export default PartnerRegistrationForm;


import React, { useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { usePartnerFormStore } from "../store/usePartnerFormStore";
import { StepWizard, type StepConfig } from "../components/ui";
import PartnerFormStep1 from "../components/PartnerFormStep1";
import PartnerFormStep2 from "../components/PartnerFormStep2";
import PartnerFormStep3 from "../components/PartnerFormStep3"; // This is the coverage plan step
import PartnerFormStep3Branch from "../components/PartnerFormStep3Branch"; // New branch step
import PartnerFormStep4 from "../components/PartnerFormStep4";
import PartnerFormStep5 from "../components/PartnerFormStep5";
import PartnerFormStep6 from "../components/PartnerFormStep6";
import PartnerFormSuccess from "../components/PartnerFormSuccess";
import { Container } from "../components/ui";

// Step Icons
const UserIcon = (
  <svg
    className="w-5 h-5"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
    />
  </svg>
);

const BriefcaseIcon = (
  <svg
    className="w-5 h-5"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    />
  </svg>
);

const PlanIcon = (
  <svg
    className="w-5 h-5"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

const LocationIcon = (
  <svg
    className="w-5 h-5"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
    />
  </svg>
);

const ChartIcon = (
  <svg
    className="w-5 h-5"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
    />
  </svg>
);

const DocumentIcon = (
  <svg
    className="w-5 h-5"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
    />
  </svg>
);

const PaymentIcon = (
  <svg
    className="w-5 h-5"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
    />
  </svg>
);

const PartnerRegistrationForm: React.FC = () => {
  const {
    currentStep,
    totalSteps,
    isSubmitted,
    resetForm,
    basicInfo,
    serviceDetails,
    coverageAreas,
    branchDetails,
    additionalInfo,
    listingDetails,
    goToStep,
  } = usePartnerFormStore();

  // Get the current service (single object)
  const currentService = serviceDetails.services;

  // Generate dynamic step summaries based on form state
  const stepConfigs: StepConfig[] = useMemo(() => {
    const getBasicInfoSummary = () => {
      if (basicInfo.fullName && basicInfo.mobileNumber) {
        return `${basicInfo.fullName}`;
      }
      return undefined;
    };

    const getServiceSummary = () => {
      if (currentService.category) {
        const subcategoryCount = currentService.subcategories?.length || 0;
        return `${subcategoryCount} subcategor${subcategoryCount !== 1 ? 'ies' : 'y'} in ${currentService.category}`;
      }
      return undefined;
    };

    const getPlanSummary = () => {
      if (coverageAreas.selectedPlan) {
        const planName = coverageAreas.selectedPlan.displayName;
        return `${planName} plan selected`;
      }
      return undefined;
    };

    const getBranchSummary = () => {
      if (branchDetails?.branchName) {
        return branchDetails.branchType
          ? `${branchDetails.branchName} (${branchDetails.branchType.replace('_', ' ')})`
          : branchDetails.branchName;
      }
      return undefined;
    };

    const getAdditionalSummary = () => {
      if (additionalInfo.incomeSharingPercentage) {
        return `${additionalInfo.incomeSharingPercentage}% income share`;
      }
      return undefined;
    };

    const getListingSummary = () => {
      if (listingDetails.listingAmount > 0) {
        return `₹${listingDetails.listingAmount.toFixed(0)}`;
      }
      return undefined;
    };

    return [
      {
        label: "Basic Info",
        icon: UserIcon,
        description: "Your business details",
        summary: getBasicInfoSummary(),
      },
      {
        label: "Services",
        icon: BriefcaseIcon,
        description: "Select your services",
        summary: getServiceSummary(),
      },
      {
        label: "Plan",
        icon: PlanIcon,
        description: "Choose coverage plan",
        summary: getPlanSummary(),
      },
      {
        label: "Branch",
        icon: LocationIcon,
        description: "Primary branch details",
        summary: getBranchSummary(),
      },
      {
        label: "Work & Income",
        icon: ChartIcon,
        description: "Additional details",
        summary: getAdditionalSummary(),
      },
      {
        label: "Summary",
        icon: DocumentIcon,
        description: "Review selections",
        summary: getListingSummary(),
      },
      {
        label: "Payment",
        icon: PaymentIcon,
        description: "Complete registration",
        summary: undefined,
      },
    ];
  }, [
    basicInfo,
    currentService,
    coverageAreas,
    branchDetails,
    additionalInfo,
    listingDetails,
  ]);

  // Show success screen if form is submitted
  if (isSubmitted) {
    return <PartnerFormSuccess />;
  }

  const handleResetForm = () => {
    if (
      window.confirm(
        "Are you sure you want to reset the form? All your progress will be lost.",
      )
    ) {
      resetForm();
    }
  };

  const handleStepClick = (step: number) => {
    // Only allow going back to previous steps
    if (step < currentStep) {
      goToStep(step);
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <PartnerFormStep1 />;
      case 2:
        return <PartnerFormStep2 />;
      case 3:
        return <PartnerFormStep3 />; // Plan selection step
      case 4:
        return <PartnerFormStep3Branch />; // Branch details step
      case 5:
        return <PartnerFormStep4 />; // Additional work & income
      case 6:
        return <PartnerFormStep5 />; // Summary
      case 7:
        return <PartnerFormStep6 />; // Payment
      default:
        return <PartnerFormStep1 />;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-50 via-blue-50/40 to-sky-50 py-4 md:py-8 relative overflow-hidden">
      {/* Animated Background Elements - Hidden on mobile */}
      <div className="hidden md:block absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-primary-200/20 rounded-full blur-3xl animate-pulse" />
        <div
          className="absolute -bottom-40 -left-40 w-80 h-80 bg-primary-300/20 rounded-full blur-3xl animate-pulse"
          style={{ animationDelay: "1s" }}
        />
      </div>

      <Container>
        <div className="max-w-4xl mx-auto relative z-10 px-3 md:px-0">
          {/* Compact Header for Mobile */}
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="mb-4 md:mb-6"
          >
            {/* Mobile Header - More compact */}
            <div className="md:hidden flex items-center justify-between gap-3">
              <div className="flex items-center gap-3">
                <div className="relative bg-white p-2 rounded-xl shadow-md border border-primary-100">
                  <img
                    src="/logo.png"
                    alt="Setgo Logo"
                    className="h-8 w-8 object-contain"
                  />
                </div>
                <div>
                  <h1 className="text-lg font-bold text-secondary-900">
                    Partner Registration
                  </h1>
                  <p className="text-xs text-secondary-500">
                    Join Setgo Network
                  </p>
                </div>
              </div>
              {currentStep > 1 && (
                <button
                  onClick={handleResetForm}
                  className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors"
                  title="Reset form"
                >
                  <svg
                    className="h-5 w-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                    />
                  </svg>
                </button>
              )}
            </div>

            {/* Desktop Header */}
            <div className="hidden md:block text-center">
              <div className="inline-flex items-center justify-center mb-4">
                <div className="relative">
                  <div className="absolute inset-0 bg-primary-500/20 rounded-full blur-xl" />
                  <div className="relative bg-white p-4 rounded-2xl shadow-lg border-2 border-primary-100">
                    <img
                      src="/logo.png"
                      alt="Setgo Logo"
                      className="h-12 w-12 object-contain"
                    />
                  </div>
                </div>
              </div>
              <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                <div className="flex-1">
                  <h1 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-primary-600 to-primary-800 bg-clip-text text-transparent mb-2">
                    Build Your Business with Setgo
                  </h1>
                  <p className="text-secondary-600 text-base md:text-lg">
                    Complete the form below to list your business on Setgo
                  </p>
                </div>
                {currentStep > 1 && (
                  <button
                    onClick={handleResetForm}
                    className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-red-600 bg-red-50 border border-red-200 rounded-lg hover:bg-red-100 hover:border-red-300 transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                    title="Reset form and clear all data"
                  >
                    <svg
                      className="h-4 w-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      />
                    </svg>
                    <span>Reset Form</span>
                  </button>
                )}
              </div>
            </div>
          </motion.div>

          {/* Step Wizard */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4, delay: 0.1 }}
            className="mb-4 md:mb-6"
          >
            <div className="bg-white/90 backdrop-blur-sm rounded-xl p-4 md:p-6 shadow-lg border border-secondary-100">
              <StepWizard
                currentStep={currentStep}
                totalSteps={totalSteps}
                steps={stepConfigs}
                onStepClick={handleStepClick}
                allowStepClick={true}
              />
            </div>
          </motion.div>

          {/* Form Card */}
          <AnimatePresence mode="wait">
            <motion.div
              key={currentStep}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
              className="bg-white/95 backdrop-blur-sm rounded-xl shadow-xl border border-secondary-100 p-4 md:p-6 lg:p-8 relative overflow-hidden"
            >
              {/* Decorative gradient overlay */}
              <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary-400 via-primary-500 to-primary-400" />

              {renderStep()}
            </motion.div>
          </AnimatePresence>

          {/* Mobile Bottom Padding for safe area */}
          <div className="h-4 md:h-0" />
        </div>
      </Container>
    </div>
  );
};

export default PartnerRegistrationForm;